import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Seo from "@/components/Seo";
import Nav from "@/components/Nav";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import Prueba from "@/components/sections/Prueba";
import Manifesto from "@/components/sections/Manifesto";
import IASection from "@/components/sections/IASection";
import Servicios from "@/components/sections/Servicios";
import Guia from "@/components/sections/Guia";
import MapaZonas from "@/components/sections/MapaZonas";
import Protocolo from "@/components/sections/Protocolo";
import Nosotros from "@/components/sections/Nosotros";
import Cotizar from "@/components/sections/Cotizar";
import Footer from "@/components/sections/Footer";
import SeoPage from "@/pages/SeoPage";
import {
  CotizarPage,
  NosotrosPage,
  ProtocoloPage,
  BlogPage,
  ArticlePage,
  NotFoundPage,
} from "@/pages/StaticPages";
import { GENERIC_PAGES } from "@/data/pages";
import PanelPage from "@/pages/PanelPage";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "Fumiga",
  description:
    "Aplicación agrícola con drones en Santa Cruz de la Sierra, Bolivia. Soya, sorgo, maíz, caña de azúcar y girasol.",
  areaServed: [
    "Santa Cruz de la Sierra",
    "Cuatro Cañadas",
    "Pailón",
    "San Julián",
    "Okinawa",
    "Montero",
    "Mineros",
    "Chiquitania",
  ],
  sameAs: ["https://instagram.com/fumigasrl", "https://facebook.com/fumigasrl", "https://www.tiktok.com/@fumigasrl"],
};

const Home = () => (
  <>
    <Seo
      title="FUMIGA · Aplicación agrícola con drones en Santa Cruz"
      siteName="Fumiga"
      description="Pulverización, fertilización y siembra con drones en soya, caña, sorgo y maíz en Santa Cruz, Bolivia. El futuro no pisa, nosotros tampoco."
      image="/fotos/compartir-og-1200x630.webp"
      jsonLd={jsonLd}
    />
    <main>
      <Hero />
      <Marquee />
      <Prueba />
      <Manifesto />
      <IASection />
      <Servicios />
      <Guia />
      <MapaZonas />
      <Protocolo />
      <Cotizar />
      <Nosotros />
    </main>
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, duration: 1.2 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-[#151A1F] text-[#F6F7F5] antialiased">
      <BrowserRouter>
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          {GENERIC_PAGES.map((p) => (
            <Route key={p.slug} path={p.slug} element={<SeoPage page={p} />} />
          ))}
          <Route path="/terrestre-vs-dron" element={<Navigate to="/" replace />} />
          <Route path="/comparativa-avion-vs-dron" element={<Navigate to="/" replace />} />
          <Route path="/protocolo" element={<ProtocoloPage />} />
          <Route path="/casos" element={<Navigate to="/" replace />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<ArticlePage />} />
          <Route path="/cotizar" element={<CotizarPage />} />
          <Route path="/nosotros" element={<NosotrosPage />} />
          <Route path="/panel" element={<PanelPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
        <WhatsAppFloat />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
